<template>
  <div>
    <PerguntaEditBase
      :close="closeEdit"
      :item="currentItem"
      :formulario="formulario"
      @salvar-pergunta="salvarPergunta"
    />

    <div class="filters row" style="margin-top: 0">
      <div class="col-1-1">
        <div class="pull-right">
          <button
            class="button button-success button-block"
            @click="createPergunta"
          >
            <fa-icon icon="plus" />
            Nova
          </button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <label v-if="perguntas.length === 0" class="text-vazio">
        Não há perguntas cadastradas. Adicione perguntas ao formulário!
      </label>

      <datatable
        v-else
        :columns="table.columns"
        :data="perguntas"
        class="table table-hover"
      >
        <template slot-scope="{ row }">
          <tr>
            <td class="custom-row">{{ row.descricao }}</td>
            <td align="center">{{ row.tipo }}</td>
            <td class="actions">
              <button
                class="button button-primary"
                @click="openEdit(row)"
              >
                <fa-icon icon="pencil-alt" />
              </button>
              &nbsp;
              <button
                class="button button-error"
                @click="deleteConfirm(row)"
              >
                <fa-icon icon="trash-alt" />
              </button>
            </td>
          </tr>
        </template>
      </datatable>
    </div>
  </div>
</template>

<script>
import PerguntaEditBase from "./PerguntaEditBase.vue";

export default {
  name: "PerguntasBase",
  components: { PerguntaEditBase },
  props: {
    perguntas: { type: Array, required: true },
    formulario: { type: Object, required: true },
  },
  data() {
    return {
      currentItem: {},
      table: {
        columns: [
          { label: "Descrição", field: "descricao", sortable: false },
          { label: "Tipo", field: "tipo", sortable: false },
          { label: "", field: "", sortable: false },
        ],
      },
    };
  },
  methods: {
    salvarPergunta(perguntaAtualizada) {
      const index = this.formulario.perguntas.findIndex(
        (p) => p.id === perguntaAtualizada.id
      );
      if (index !== -1) {
        this.$set(this.formulario.perguntas, index, { ...perguntaAtualizada });
      } else {
        const novaPergunta = {
          ...perguntaAtualizada,
          id: perguntaAtualizada.id ?? null,
        };
        this.formulario.perguntas.push(novaPergunta);
      }
    },
    deleteConfirm(pergunta) {
      const index = this.formulario.perguntas.findIndex(
        (p) => p.id === pergunta.id
      );
      if (index !== -1) {
        this.formulario.perguntas.splice(index, 1);
      }
    },
    openEdit(item) {
      this.currentItem = item;
      this.$modal.show("perguntaEdit");
    },
    createPergunta() {
      this.currentItem = {};
      this.$modal.show("perguntaEdit");
    },
    closeEdit() {
      this.$modal.hide("perguntaEdit");
    },
  },
};
</script>

<style scoped>
.custom-row {
  width: 600px !important;
}
.text-vazio {
  text-align: center;
  width: 100%;
  font-size: 1rem;
  margin-top: 1rem;
  color: #999;
}
</style>
